import { BillingData } from 'gw-edge-client';
import { selector } from 'recoil';
import { mpsActivationInfoAtom } from '../atoms/mpsActivationInfoAtom';
import type { MpsStatusResponseDTO } from 'gw-edge-client/dist/types/dto/bc/edge/capabilities/billing/dto';

export const getMpsStatusSelector = selector<MpsStatusResponseDTO>({
    key: 'getMpsStatusSelector',
    get: async ({ get }) => {
        const mpsActivationInfo = get(mpsActivationInfoAtom);
        const response = await BillingData.getMpsStatus(mpsActivationInfo.policeNummer).catch(
            (e) => {
                return {};
            }
        );
        return response;
    }
});
